import { getDependency, registerDependency } from '~/common/di';
import { SessionService } from './services';
import { SessionAuthDataProvider, SessionStorageDataProvider } from './common';

registerDependency('SESSION_SERVICE', () => new SessionService());

export const useSessionService = () => getDependency<SessionService>('SESSION_SERVICE');
export const useSessionAuthDataProvider = () => getDependency<SessionAuthDataProvider>('SESSION_AUTH_DATA_PROVIDER');
export const useSessionStorageDataProvider = () => getDependency<SessionStorageDataProvider>('SESSION_STORAGE_DATA_PROVIDER');
